/**
 * Tri des sous-catégories pour la saisie guidée : les épinglés (flag `pinned`
 * DATA-DRIVEN en base, posé par TAXO-B lot final) en tête — ordonnés ENTRE EUX
 * par leur `order` — puis le RESTE en alphabétique localisé.
 *
 * TAXO-C avait introduit une constante FE temporaire (PINNED_SUBCAT_CODES) faute
 * de mécanisme code ; TAXO-B lot final l'a remplacée par le flag `pinned` en base
 * (exposé tel quel par GET /subcategories, sans projection) → la constante a été
 * SUPPRIMÉE. `pinned === true` strict : un doc sans le champ n'est pas épinglé.
 */

/**
 * @param {Array} subcats - sous-catégories ({ code, name_fr, name_de, pinned, order, ... }).
 * @param {string} lang - 'fr' | 'de'.
 * @returns {Array} nouvelle liste triée (n'altère pas l'entrée).
 */
export const sortSubcategoriesForDisplay = (subcats, lang) => {
  const nameField = lang === 'de' ? 'name_de' : 'name_fr';
  return [...subcats].sort((a, b) => {
    const pa = a.pinned === true;
    const pb = b.pinned === true;
    if (pa !== pb) return pa ? -1 : 1;                        // épinglés d'abord
    if (pa && pb) return (a.order ?? 9999) - (b.order ?? 9999); // entre épinglés : order
    // Reste : alphabétique localisé (order ignoré), trim défensif + insensible accents/casse.
    const nameA = (a[nameField] || a.name_fr || '').trim();
    const nameB = (b[nameField] || b.name_fr || '').trim();
    return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
  });
};
